import { LayoutContext, ScreenSize } from 'contexts/LayoutContext';
import { styled, View } from 'dripsy';
import React, { useContext } from 'react';
import { Image } from 'react-native';
import RightGraphic from '../../../../assets/svg/right_graphic.svg';

const GraphicComponent = React.memo(() => {
  const ImageView = styled(Image)();
  const layout = useContext(LayoutContext);
  const isFullDesktop = layout.screenSize === ScreenSize.DesktopFull;
  return layout.isMobile ? (
    <View>
      <ImageView sx={{ height: 230, width: 220 }} resizeMode="cover" source={require('../../../../assets/images/right_graphic.jpeg')} />
    </View>
  ) : (
    <View>
      <RightGraphic width={isFullDesktop ? 562 : '100%'} height={600} />
    </View>
  );
});
export default React.memo(GraphicComponent);
